/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from '@reduxjs/toolkit';

// فقط افترض أن الريودسر مُسجّل باسم `userLogin` في الـ root
export const selectAuthUser = (state: any) => state.userLogin?.AuthUser;

export const getPersonId = createSelector(selectAuthUser, AuthUser => AuthUser?.personId || null);

export const getBusinessGroupIdForPerson = createSelector(
  selectAuthUser,
  AuthUser => AuthUser?.businessGroupId || null
);


// سيليكتر لإرجاع قائمة الصلاحيات كـ Array
export const selectPermissionsArray = createSelector([selectAuthUser], authUser => {
  const permissions = authUser?.permission || '';
  return permissions ? permissions?.split(',') : [];
});


// **السيليكتر الجديد للتحقق من وجود المالية**
export const activeFinanceSelector = createSelector(selectAuthUser, AuthUser => AuthUser?.activeFinance ?? false);
